// extracted by mini-css-extract-plugin
export default {"row":"AddForm_row__09ErL","smallSubmit":"AddForm_smallSubmit__rq43M"};